import { Box, Flex, Text } from 'rebass';
import { FaChevronDown } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

import CtaDialog from './cta/CtaDialog';
import SocialCount from './SocialCount';
import useEntity from './hooks/useEntity';

const useStoryPageFeedback = id => {
  const storyPage = useEntity({ id, type: 'pages' });
  const likes = useSelector(state => state.likes);
  const comments = useSelector(state => state.comments);

  const pageMediaIds = storyPage.media.map(params => params.id);

  const likesCount = Object.keys(likes).filter(likeId =>
    pageMediaIds.includes(likes[likeId].medium.id)
  ).length;
  const commentsCount = Object.keys(comments).filter(commentId =>
    pageMediaIds.includes(comments[commentId].medium.id)
  ).length;

  return { likesCount, commentsCount };
};

const StoryPageFeedback = ({ id }) => {
  const storyPage = useEntity({ id, type: 'pages' });
  const { likesCount, commentsCount } = useStoryPageFeedback(id);
  const [on, setOn] = useState(false);

  const onClick = useCallback(() => setOn(!on), [on]);

  if (!storyPage.media.length) return false;

  return (
    <Box ariaRole="button" onClick={onClick} style={{ cursor: 'pointer' }}>
      <Flex p={3}>
        <SocialCount likesCount={likesCount} commentsCount={commentsCount} />
        {!!commentsCount && (
          <Box ml="auto">
            <Text color="mutedText">
              <FaChevronDown />
            </Text>
          </Box>
        )}
      </Flex>
      <CtaDialog onClose={onClick} on={on} />
    </Box>
  );
};

StoryPageFeedback.defaultProps = {};

StoryPageFeedback.propTypes = {
  id: PropTypes.string.isRequired,
};

export default StoryPageFeedback;
